/**
 * True when a map field value has a user-placed location (lat/lng).
 * Values may include staticMapImage etc.; only coordinates matter for "marker on map".
 */
export function mapFieldHasPlacedMarker(value) {
  if (!value || typeof value !== 'object') return false;
  const { lat, lng } = value;
  if (lat == null || lng == null) return false;
  const nlat = typeof lat === 'number' ? lat : parseFloat(String(lat), 10);
  const nlng = typeof lng === 'number' ? lng : parseFloat(String(lng), 10);
  return Number.isFinite(nlat) && Number.isFinite(nlng);
}
